import { extends as _extends } from '../_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';
import { Grid } from '@zillow/constellation';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { generateBlockList } from '../components/BlockList/BlockList.js';
import sortMediaQuery from '../util/sort-media-query.js';

var GridContent = /*#__PURE__*/styled(Grid).withConfig({
  componentId: "sc-1xp0hn6-0"
})(["flex-direction:column;"]);
var BlockGridContent = function BlockGridContent(_ref) {
  var attrs = _ref.attrs,
    index = _ref.index,
    innerBlocks = _ref.innerBlocks;
  var attributes = Object.assign({
    backgroundColor: null,
    padding: 'none'
  }, attrs, {
    // Defaults
    gridColumnEnd: sortMediaQuery(Object.assign({
      default: 'span 1',
      sm_lte: 'span 12'
    }, attrs === null || attrs === void 0 ? void 0 : attrs.gridColumnEnd))
  });
  return /*#__PURE__*/React.createElement(GridContent, _extends({
    key: index
  }, attributes, {
    // Otherwise justifyContent and alignItems props won't have any affect.
    display: "flex"
  }), generateBlockList({
    blocks: innerBlocks
  }));
};
BlockGridContent.propTypes = process.env.NODE_ENV !== "production" ? {
  attrs: PropTypes.shape({
    gridColumnEnd: PropTypes.shape({})
  }),
  index: PropTypes.number,
  innerBlocks: PropTypes.arrayOf(PropTypes.shape({}))
} : {};
var GridContent$1 = BlockGridContent;

export { GridContent$1 as default };
